<template>
  <b-nav-item href="#"><i class="mdi mdi-image-filter"></i>{{ currentOrganisation.name }}</b-nav-item>
</template>

<script>
export default {
  name: 'organisation-menu',
  data: function () {
    return {
      organisations: [],
      currentOrganisation: {}
    }
  },
  methods: {
    // Log the user in
    async getData () {
      this.organisations = await this.$apiClient.organisationGetAll()
    }
  },
  async mounted () {
    await this.getData()
    this.currentOrganisation = this.organisations[0]
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OrganisationMenu.vue